import React from "react";
import { useTheme } from "@mui/styles";
import { useMediaQuery, Box } from "@mui/material";
import Slider from "react-slick";
import RightArrow from "../../img/RightArrow.svg";
import LeftArrow from "../../img/LeftArrow.svg";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  sliderTestimonies: {
    marginTop: "2.5rem",
    width: isMobile ? "94.5%" : "80.5%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflowX: "visible",
  },
  video: {
    borderRadius: "25px",
    overflow: "hidden",
    margin: "auto",
    height: { xl: "550px", lg: "366.6px", md: "244.4px", xs: "212.52px" },
    width: { xl: "834px", lg: "556px", md: "370.6px", xs: "322.26px" },
  },
});

const TestimoniesSlider = () => {
  const isMobile = useMediaQuery("(max-width:1000px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { videos } = useTranslation(pathname, "TestimoniesSlider");

  function Arrow(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    let className = props.type === "next" ? "nextArrow" : "prevArrow";
    className += " arrow";

    const char =
      props.type === "next" ? (
        <img
          src={RightArrow}
          alt="flecha"
          style={{
            ...classes.arrow,
            marginLeft: "15px",
          }}
        />
      ) : (
        <img
          alt="flecha"
          src={LeftArrow}
          style={{ ...classes.arrow, marginRight: "15px" }}
        />
      );

    return (
      <span className={className} onClick={props.onClick} style={classes.span}>
        {char}
      </span>
    );
  }

  return (
    <Slider
      style={classes.sliderTestimonies}
      swipeToSlide={false}
      infinite={true}
      centerMode={true}
      centerPadding="0"
      nextArrow={<Arrow type="next" />}
      prevArrow={<Arrow type="prev" />}
    >
      {videos.map((video, index) => {
        return (
          <div key={index} style={{ overflowX: "visible" }}>
            <Box sx={classes.video}>
              <iframe
                title={index}
                border="0"
                src={video}
                frameBorder="0"
                dnt="0"
                controls="0"
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
          </div>
        );
      })}
    </Slider>
  );
};

export default TestimoniesSlider;
